import { render, staticRenderFns } from "./BestSeller.vue?vue&type=template&id=5c6b93f7&scoped=true&"
import script from "./BestSeller.vue?vue&type=script&lang=js&"
export * from "./BestSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6b93f7",
  null
  
)

export default component.exports